













































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { GPageBase } from '@/mixins';
import { PagingData } from '@/models/core/paging-data';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import { Student } from '@/models/student/student';
import { SchoolClass } from '@/models/school-class/school-class';
import { GEnum } from '@/constants/enum.defination';
import { Tag } from '@/models/tag';
import GStudentFilter from '@/components/GStudentFilter.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import { studentFilterModule } from '@/store/modules/frames/student-filters.module';
import { studentModule } from '@/store/modules/entities/student.module';
import { StudentSearch } from '@/models/student/student-search';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import * as FileSaver from 'file-saver';
import GClassImport from '@/views/GStudents/GClassImport.vue';
import GStudentImport from '@/views/GStudents/GStudentImport.vue';
import { globalModule } from '@/store/modules/global.module';
import { studentSettingModule } from '@/store/modules/frames/student-setting.module';
import { lgateModule } from '@/store/modules/entities/lgate.module';
import { LgatePreLinkage } from '@/models/lgate/lgate-pre-linkage';

Component.registerHooks(['beforeRouteEnter']);
@Component({
  name: 'GStudents',
  components: {
    GStudentImport,
    GClassImport,
    GCustomBreadCrumb,
    GTitleBar,
    GStudentFilter,
  },
  computed: {},
  methods: {},
})
export default class GStudents extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  breadCrumbItemHome: BreadCrumbElement = null;
  studentListColumn: object[] = [];
  studentDataPerPage: number = 15;
  studentDataOffset: number = 0;
  isStudentFilterAwait: boolean = false;
  isStudentSearchLoading: boolean = false;
  isSearchResultShow = false;
  lazy: boolean = false;
  modalClassImport: boolean = false;
  modalStudentImport: boolean = false;
  sortKey: GEnum.StudentSortKey = GEnum.StudentSortKey.Grade;
  sortType: GEnum.SortType = GEnum.SortType.Asc;
  isRunningLgate: boolean = false;

  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      if (from.name !== 'student-edit') {
        //生徒編集画面から戻ってきた時のみ、キャッシュデータを保持する
        vm.initCurrentPage();
        vm.clearStudentFilters();
        vm.clearStudents();
      }
      vm.isStudentFilterAwait = true;
    });
  }

  @Watch('students')
  loadStudents() {
    this.isStudentSearchLoading = false;
  }

  async mounted() {
    if (this.isOldSchoolYear) {
      this.breadCrumbItemHome = { title: this.$t('HOME').toString(), icon: 'ios-home' }; //リンクなし
    } else {
      this.breadCrumbItemHome = { title: this.$t('HOME').toString(), icon: 'ios-home', routerPath: '/pages/home' };
    }
    this.breadCrumbItems = [
      this.breadCrumbItemHome,
      { title: this.$t('SETTING_AND_MANAGEMENT').toString() },
      { title: this.$t('REGISTERED_PERSON_INFORMATION').toString() },
    ];
    this.createColumn();

    await schoolClassModule.fetchSchoolClasses();
    this.lazy = true;

    // L-Gate モジュールをクリア
    lgateModule.clear();

    // 初回検索実行
    this.$nextTick(() => {
      if (this.isExistSchoolClasses) {
        // refsを用いて、生徒検索フィルターのインスタンスが生成されたあとに検索実行する
        const { gStudentFilter }: any = this.$refs;
        gStudentFilter.handleFormSubmit();
      }
    });
  }

  get isDisplayTrend(): boolean {
    // 追加サービスプランに傾向チェックが含まれている場合、表示する
    return this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademic);
  }

  get isOldSchoolYear(): boolean {
    return globalModule.isOldSchoolYear;
  }

  get isExistSchoolClasses(): boolean {
    return schoolClassModule.schoolClasses.length > 0;
  }

  get tags(): Tag[] {
    return studentFilterModule.tags;
  }

  get grade(): number {
    return studentFilterModule.grade;
  }

  get schoolClassID(): number {
    return studentFilterModule.schoolClassID;
  }

  get searchWord(): string {
    return studentFilterModule.searchWord;
  }

  get studentNumber(): string {
    return studentFilterModule.studentNumber;
  }

  get students(): PagingData<Student> {
    return studentModule.students as PagingData<Student>;
  }

  get schoolClasses(): SchoolClass[] {
    return schoolClassModule.schoolClasses as SchoolClass[];
  }

  get targetType(): number {
    return studentFilterModule.targetType;
  }

  get targetID(): number {
    return studentFilterModule.targetID;
  }

  get currentPage(): number {
    return studentSettingModule.currentPage;
  }

  // L-Gate連携の設定をしている学校か
  get isLgateSchool(): boolean {
    return this.$store.state.account.isLgateSchool;
  }

  clearStudents() {
    studentModule.clearStudents();
  }

  createColumn() {
    this.studentListColumn = [
      this.columnStudentNumber,
      this.columnName,
      this.columnGrade,
      this.columnSchoolClassName,
      this.columnManageNumber,
      this.columnTags,
      this.columnPriorityTag,
      this.columnFeedbackReport,
      ...this.columnTrendReport,
      this.action,
    ];
  }

  clearStudentFilters() {
    studentFilterModule.clear();
  }

  get columnStudentNumber() {
    return {
      title: this.$t('LOGIN_ID').toString(),
      key: 'studentNumber',
      //sortable: this.columnIDSortable,
      sortable: 'custom',
      width: 120,
      align: 'center',
    };
  }

  get columnName() {
    return {
      title: this.$t('FULL_NAME').toString(),
      key: 'firstName',
      width: 150,
      align: 'center',
      render: (h: any, params: any) => {
        const selectedRow: any = this.students.data[params.index];
        return h(
          'Tooltip',
          {
            props: {
              content: selectedRow.fullName,
              placement: 'right',
              ['max-width']: 200,
              disabled: !this.isOverLength(selectedRow.fullName, 8),
            },
          },
          [h('span', {}, this.simpleText(selectedRow.fullName, 8))]
        );
      },
    };
  }

  get columnGrade(): any {
    return {
      title: this.$t('GRADE').toString(),
      key: 'schoolClass',
      sortable: 'custom',
      width: 80,
      align: 'center',
      render: (h: any, params: any) => {
        const selectedRow: Student = this.students.data[params.index];
        const schoolYear = selectedRow.schoolClass.grade;
        return h('span', {}, schoolYear);
      },
    };
  }

  get columnSchoolClassName(): any {
    return {
      title: this.$t('SCHOOL_CLASS').toString(),
      key: 'schoolClassName',
      sortable: 'custom',
      width: 150,
      align: 'center',
      render: (h: any, params: any) => {
        const student: Student = this.students.data[params.index];
        const schoolClassName = student.schoolClass.schoolClassName;
        return h(
          'Tooltip',
          {
            props: {
              content: schoolClassName,
              placement: 'right',
              ['max-width']: 200,
              disabled: !this.isOverLength(schoolClassName, 12),
            },
          },
          [h('span', {}, this.simpleText(schoolClassName, 12))]
        );
      },
    };
  }

  get columnManageNumber() {
    return {
      title: this.$t('MANAGE_NUMBER').toString(),
      key: 'manageNumber',
      sortable: 'custom',
      width: 100,
      align: 'center',
    };
  }

  get columnTags() {
    return {
      title: this.$t('TAG').toString(),
      width: 300,
      align: 'center',
      slot: 'tag',
    };
  }

  get columnPriorityTag() {
    return {
      title: this.$t('PRIORITY_TAG').toString(),
      width: 100,
      align: 'center',
      slot: 'priorityTag',
    };
  }

  get columnFeedbackReport() {
    return {
      title: this.$t('PERSONAL_REPORT').toString(),
      align: 'center',
      width: 180,
      slot: 'report',
      children: [
        {
          title: this.$t('SELF_GROWTH_SUPPORT_REPORT').toString(),
          slot: 'report-default',
          width: 110,
          align: 'center',
        },
        {
          title: this.$t('STRENGTH_FIND').toString(),
          slot: 'report-simple',
          align: 'center',
        },
      ],
    };
  }

  get columnTrendReport(): any[] {
    // if (this.isDisplayTrend) {
    //   return [
    //     {
    //       title: '傾向チェック',
    //       key: 'trendReportURL',
    //       align: 'center',
    //       render: (h: any, params: any) => {
    //         const selectedRow: Student = this.students.data[params.index];
    //         if (selectedRow.trendReportURL === '' || !this.isShowReportURL(selectedRow.schoolClass.schoolClassID)) {
    //           return h('span', 'ー');
    //         }
    //         return h(
    //           'a',
    //           {
    //             on: {
    //               click: () => {
    //                 window.open(selectedRow.trendReportURL);
    //                 return;
    //               },
    //             },
    //             props: {
    //               href: selectedRow.trendReportURL,
    //             },
    //           },
    //           this.$t('DETAIL').toString()
    //         );
    //       },
    //     },
    //   ];
    // } else {
    return [];
    // }
  }

  get action() {
    return {
      title: ' ',
      key: 'action',
      width: 50,
      align: 'center',
      render: (h: any, params: any) => {
        const selectedRow: Student = this.students.data[params.index];
        return h('div', [
          h(
            'a',
            {
              props: {
                type: 'primary',
                size: 'small',
              },
              style: {
                marginRight: '5px',
              },
              on: {
                click: () => {
                  this.$router.push(`/pages/student-edit/${selectedRow.studentID}`);
                },
              },
            },
            this.showEditLink(selectedRow.schoolClass.schoolClassID)
          ),
        ]);
      },
    };
  }

  showEditLink(schoolClassID: number): string {
    if (this.isRoleIgsAdmin || (!this.isOldSchoolYear && (this.isRoleAdmin || this.$store.state.account.isResponsibleSchoolClass(schoolClassID)))) {
      //管理者権限を持っているか、または、自分の編集画面である場合のみ表示
      return this.$t('TEACHER_EDIT_LINK').toString();
    } else {
      return '';
    }
  }

  isShowReport(row: any): boolean {
    const { reportURL, simpleReportURL, schoolClass } = row;
    if (reportURL === '' || simpleReportURL === '') {
      return false;
    }
    return this.isShowReportURL(schoolClass.schoolClassID);
  }

  isShowReportURL(schoolClassID: number): boolean {
    if (this.isRoleIgsAdmin || (!this.isOldSchoolYear && (this.isRoleAdmin || this.$store.state.account.isResponsibleSchoolClass(schoolClassID)))) {
      //管理者権限を持っているか、または、自分の編集画面である場合のみ表示
      return true;
    } else {
      return false;
    }
  }

  initCurrentPage() {
    studentSettingModule.setCurrentPage(1);
  }

  get isRoleIgsAdmin(): boolean {
    return this.$store.state.account.isRoleIgsAdmin;
  }

  get isRoleAdmin(): boolean {
    return this.$store.state.account.isRoleAdmin;
  }

  get isRoleNormal(): boolean {
    return this.$store.state.account.isRoleNormal;
  }

  get linkageDone(): boolean {
    return lgateModule.preLinkage;
  }
  set linkageDone(value: boolean) {
    lgateModule.setPreLinkage(value);
  }


  get linkageData(): LgatePreLinkage {
    return lgateModule.preLinkageData;
  }

  handleSort(event: any) {
    if (!event) {
      return;
    }
    this.sortType = event.order == 'desc' ? GEnum.SortType.Desc : GEnum.SortType.Asc;
    // key:fullName(sortKey=2)は廃止
    switch (event.key) {
      case 'studentNumber':
        this.sortKey = GEnum.StudentSortKey.StundentNumber;
        break;
      case 'schoolClass':
        this.sortKey = GEnum.StudentSortKey.Grade;
        break;
      case 'schoolClassName':
        this.sortKey = GEnum.StudentSortKey.Class;
        break;
      case 'manageNumber':
        this.sortKey = GEnum.StudentSortKey.ManageNumber;
        break;
    }
    this.handleSearchStudents();
  }

  handleSearchSubmit(): void {
    this.studentDataPerPage = 15;
    this.studentDataOffset = 0;
    this.isSearchResultShow = true;
    this.initCurrentPage();
    this.handleSearchStudents();
  }

  handlePagerChange(pageNumber: number) {
    this.studentDataOffset = (pageNumber - 1) * this.studentDataPerPage;
    studentSettingModule.setCurrentPage(pageNumber);
    this.handleSearchStudents();
  }

  handleSearchStudents() {
    this.isStudentSearchLoading = true;
    this.isSearchResultShow = true;
    let studentSearchOptions: StudentSearch = {
      targetType: this.targetType,
      targetID: this.targetID,
      keyword: this.searchWord,
      selectedTagIDs: studentFilterModule.commaSelectedTagIDs,
      offset: this.studentDataOffset,
      limit: this.studentDataPerPage,
      sortKey: this.sortKey,
      sortType: this.sortType,
      studentNumber: this.studentNumber,
    };
    studentModule.fetchStudents(studentSearchOptions);
    studentFilterModule.setLatestStudentSearchOptions(studentSearchOptions);
  }

  handleStudentListDownload() {
    this.isRunning = true;
    studentFilterModule.downloadStudentsExcelFile().then((response: any) => {
      this.isRunning = false;
      FileSaver.saveAs(response, this.$t('FILE_NAME.STUDENT_REGISTRATION_TEMPLATE').toString());
    });
  }

  // L-Gate 連携ボタン押下での差分チェック
  handlePreLgateLinkage() {
    console.log("handlePreLgateLinkage()")
    this.isRunningLgate = true;
    lgateModule.requestPreLinkage().then((res: any) => {
      this.isRunningLgate = false;
      console.log(res);
    });
  }

  // L-Gate 連携ボタン押下での差分チェック後、実際の連携実施
  handleDoLgateLinkage() {
    console.log("handleDoLgateLinkage()")
    this.isRunningLgate = true;
    lgateModule.requestLinkage().then((res: any) => {
      this.isRunningLgate = false;
      console.log(res);
      this.showNotice(GEnum.MessageType.Success, "連携が完了しました");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    });
  }
}
